import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import L from 'leaflet';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon, FilePlusIcon } from 'lucide-react';
import { RequestComposer } from '../components/demandes/RequestComposer';
import { PublicReportsMap } from '../components/demandes/PublicReportsMap';
import { RequestList } from '../components/demandes/RequestList';
import { AtnaConversationDialog } from '../components/demandes/AtnaConversationDialog';
import { profileCoordinates, reportCategoryFor, type PublicReport } from '../data/demandes';
interface MapPick {
  address: string;
  position: [number, number];
}
export function MesDemandes() {
  // Lieu choisi sur la carte : ouvre ATNA avec l'adresse déjà remplie.
  const [mapPick, setMapPick] = useState<MapPick | null>(null);
  // Signalements envoyés depuis la carte pendant la session : ils y apparaissent aussitôt.
  const [sentReports, setSentReports] = useState<PublicReport[]>([]);
  const addToMap = (pick: MapPick, intentLabel: string) => {
    setSentReports(current => [{
      id: `pub-atna-${Date.now()}`,
      category: reportCategoryFor(intentLabel),
      title: intentLabel,
      address: pick.address,
      distance: formatDistance(L.latLng(profileCoordinates).distanceTo(pick.position)),
      reportedAgo: 'à l’instant',
      status: 'nouveau',
      confirmations: 0,
      lat: pick.position[0],
      lng: pick.position[1]
    }, ...current]);
  };
  return <main className="bg-white" data-id="element-3224" data-mp="3ewrq1tprr3qt">
      <div className="mx-auto max-w-[1180px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-3225" data-mp="3f05r8ymp56wo">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-3226" data-mp="3jxntk667knvp">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-3227" data-mp="3ny7r3aup1tid">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3228" data-mp="1plhir8h8893x" />
          <span aria-current="page" data-id="element-3229" data-mp="1tl8dtodsdbe9">Mes demandes</span>
        </nav>

        <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-3230" data-mp="2wuudj1jwx18c">Mes demandes</h1>

        <div className="mt-8" data-id="element-3231" data-mp="2rxknpksm2njz">
          <RequestComposer action={<Link to="/mes-demandes/nouvelle" className="inline-flex h-[66px] items-center gap-2.5 whitespace-nowrap rounded-full border border-slate-200 px-7 text-base font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-3233" data-mp="35wkdivrv18hq">
                <FilePlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-3234" data-mp="3pji2b73ve8qn" />
                Nouvelle demande
              </Link>} data-id="element-3232" data-mp="2ryngxzdep232" />
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-10" data-id="element-3235" data-mp="2etwb6f6beav">
          <PublicReportsMap onReportAt={(address, position) => setMapPick({
          address,
          position
        })} extraReports={sentReports} data-id="element-3236" data-mp="3tmo86dn2lxwl" />
          <RequestList data-id="element-3237" data-mp="h0hcyhm640oz" />
        </div>
      </div>

      <AnimatePresence data-id="element-3238" data-mp="m0c3gk216o9i">
        {mapPick !== null && <AtnaConversationDialog key={`atna-carte-${mapPick.position.join(',')}`} initialText={`Je veux signaler un problème ici : ${mapPick.address}`} presetAddress={mapPick.address} layoutId="atna-carte-panel" onSent={intentLabel => addToMap(mapPick, intentLabel)} onClose={() => setMapPick(null)} data-id="element-3239" data-mp="81m6r5j4iqlo" />}
      </AnimatePresence>
    </main>;
}
function formatDistance(meters: number): string {
  if (meters < 1000) return `${Math.max(10, Math.round(meters / 10) * 10)} m`;
  return `${(meters / 1000).toFixed(1).replace('.', ',')} km`;
}